import logo from '../../assets/logo.png';

const meta = {
  title: 'Cruzeiro Esporte Clube',
  description: 'Site oficial do Cruzeiro. Acompanhe todas as notícias do time, encontre produtos oficiais, confira o calendário de jogos e garanta os seus ingressos. Seja Sócio 5 Estrelas!',
  image: logo,
}

export default meta;